import {CreateInstance} from './config'
const ColumnReturnAPI = CreateInstance('column_return')
export default ColumnReturnAPI
